var iRowWidth = 40		// 行宽
var iFontSize = 24		// 正常的字体显示
var iMinRows = 11		// 最小行数，即当一页中的行数小于此数时，则加上一些空行，如果设置为0，则表示按照实际行数显示
var iShowBookName = 1		// 是否显示书脊，１：显示，０：不显示

var arrayRows = new Array() 	// 保存XML中的每一行
var objDivRebuildPage
var iPageNo
var iTotalPages
var bIe = IEVersion()
var cTurnRed = '' // 关键词检索
var cBookName = ''
var currentPage = 0
// 根据页号加载XML文件，生成的内容保存到div中
function LoadPageXML2 (nPageNo, sDivId, nBzd) {
  objDivRebuildPage = document.getElementById(sDivId)
  $(objDivRebuildPage).empty()	// 清空原来的内容
  arrayRows = []	// 清空数组
  iTotalPages = nLast
  iPageNo = nPageNo
  if (cTurnRed != '') {
    if (cTurnRed.indexOf('%') > -1) {
      cTurnRed = decodeURIComponent(cTurnRed)
    }
    cTurnFt = s2t(cTurnRed) // 简体转繁体
    cTurnRedFt = cTurnFt
    if (cTurnFt != cTurnRed) { cTurnRedFt = cTurnFt + '|' + cTurnRed }
  }

  // 获取该页的XML文件名
  var sXmlFn = cImg + pic_array[nPageNo]
  sXmlFn = sXmlFn.substr(0, sXmlFn.length - 3) + 'xml'

  // 解析XML，将结果保存到objDivPage中
  ParseXml2(objDivRebuildPage, sXmlFn)
}

// 根据xml文件显示竖版文字
function ParseXml2 (xml, bookName, page) {
  objDivRebuildPage = document.getElementById('sDivId')
  $(objDivRebuildPage).empty()
  cBookName = bookName
  currentPage = page
  arrayRows = []	// 清空数组
  //   $.ajax(
  //     {
  //       url: sXmlFn,	// XML文件相对路径
  //       type: 'get',				// 发送请求的方式
  //       dataType: 'text', // 指明文件类型为“xml”
  //       timeout: 1000, // 超时设置，单位为毫秒
  //       error: function (xml) { // 解析XML文件错误时的处理
  // 		   alert('加载XML文件（' + sXmlFn + '）出错！请检查该文件是否存在或者格式是否正确！')
  //       },
  //       success: function (xml) {
  // 先读出每一行放到数组中
		   	$(xml).find('row').each(function (iRow) {
		   		var sOneLine = $(this).html()
		   		sOneLine = sOneLine.replace('\r', '')
    sOneLine = sOneLine.replace('\n', '')
    //   if (g_isJt == 1) // 要转为简体
    //     		{ sOneLine = t2s(sOneLine) }
    arrayRows[arrayRows.length] = sOneLine
		    })

  // 生成显示内容
  ShowOnePage2(objDivRebuildPage)
  //   }
  // })
}

// 显示一页，生成内容保存到objDivPage中
function ShowOnePage2 (objDivRebuildPage) {
  var objDivRebuildPage = document.getElementById('sDivId')
  $(objDivRebuildPage).empty() // 清空原来的内容
  // 创建一个新的DIV，用于显示一页的数据
  var objDivPage = document.createElement('div')
  objDivRebuildPage.appendChild(objDivPage)
  objDivPage.className = 'div_page2'

  var i
  var iMaxWords = 0	// 最长行的字数
  var sOneLine
  var iTotalRowCount = arrayRows.length	// 需要显示的总行数
  var iWordRowCount = arrayRows.length		// 有文字的总行数
  var iStartShowRowNo = 0	// 从屏幕上的第几行开始显示

  // 计算一页中行的最多字数
  for (i = 0; i < iTotalRowCount; i++) {
    sOneLine = arrayRows[i]
    var iLen = GetOneLineLen2(sOneLine)
    if (iLen > iMaxWords) { iMaxWords = iLen }
  }

  if (iTotalRowCount < iMinRows) {
    	iTotalRowCount = iMinRows
    	iStartShowRowNo = parseInt((iTotalRowCount - iWordRowCount) / 2)
  }
  var iDivPageWidth = iTotalRowCount * iRowWidth	// 需要显示的宽度
  var iDivPageHeight = iMaxWords * (iFontSize + iFontSize * 0.13) + 52// +iFontSize*0.5;	//需要显示的高度

  // 页面高度不少于580
  if (iDivPageHeight < 580) { iDivPageHeight = 580 }
  // 页面高度超过700，则根据最长的字符串长度进行计算
  if (iDivPageHeight > 700) { objDivRebuildPage.style.height = (iDivPageHeight + 60) + 'px' }

  // 设置页的坐标
  objDivPage.style.left = ((800 - iDivPageWidth) / 2) + 'px'
  objDivPage.style.width = iDivPageWidth + 'px'
  objDivPage.style.height = (iDivPageHeight) + 'px'

  var iRowLeft
  // 处理每一行
  var bFirst = true
  for (i = 0; i < iTotalRowCount; i++) {
    // 计算一行的坐标，生成div
    iRowLeft = iDivPageWidth - (i + 1) * iRowWidth
    var objDivRow_Line = document.createElement('div')
    objDivPage.appendChild(objDivRow_Line)
    objDivRow_Line.className = 'div_row2'
    // 设置行的坐标
    objDivRow_Line.style.left = iRowLeft + 'px'
    objDivRow_Line.style.height = (iDivPageHeight) + 'px'
    objDivRow_Line.style.width = (iRowWidth - 2) + 'px'

    if (i >= iStartShowRowNo && i < iStartShowRowNo + iWordRowCount) {
      // 取出一行内容，进行判断
      sOneLine = arrayRows[i - iStartShowRowNo]
      sOneLine = sOneLine.replace('<mark type="select.start" kind="SELECT"></mark>', '')
      sOneLine = sOneLine.replace('<mark type="select.end"></mark>', '')

      if (bIe == -1) // 非IE浏览器转换，因为界面上会显示白框，IE不显示
      { sOneLine = sOneLine.replace(/䶻/g, '　') }

      if (sOneLine.indexOf('<mark') >= 0) {
        // 行中有标记，分析行中的具体内容，结果保存到objDivRow_Line中
        ParseOneLine2(objDivRow_Line, sOneLine)
      } else {
        if (sOneLine.length != 0) {
          // 无标记，直接放到一行的div中
          var objDivRow = document.createElement('div')
          objDivRow.className = 'div_row_words'
          objDivRow.style.left = (iRowWidth - iFontSize) / 2 + 'px'
          objDivRow.style.height = (iDivPageHeight - 12) + 'px'
          objDivRow.style.width = iFontSize + 'px'
          objDivRow.style.fontSize = iFontSize + 'px'
          objDivRow_Line.appendChild(objDivRow)
          cOneNew = sOneLine
          if (cTurnRed.length > 0) {
            cRepl = '/' + cTurnRed + '/g'
			      		cOneNew = cOneNew.replace(eval(cRepl), '<font color=red>' + cTurnRed + '</font>')
			      		if (cTurnFt != cTurnRed) {
			      			cReplFt = '/' + cTurnFt + '/g'
			            	cOneNew = cOneNew.replace(eval(cReplFt), '<font color=red>' + cTurnFt + '</font>')
			            }
			        }
            		// sOneLine=AddDiv(sOneLine);
          objDivRow.innerHTML = cOneNew
        } else {
          if (i >= Math.floor(iTotalRowCount / 2) - 1 && i <= Math.floor(iTotalRowCount / 2) + 1 && iShowBookName == 1) {
            // 在书脊位置显示书名
            if (bFirst == true) {
              AddBookName2(objDivRow_Line)
              bFirst = false
            }
          }
        }
      }
    }
  }

  // 增加缩放按键
//   var objDivBack = document.createElement('div')
//   var objDivZoomin = document.createElement('div')
//   var objDivZoomout = document.createElement('div')
//   var objDivPrevPage = document.createElement('div')
//   var objDivNextPage = document.createElement('div')
//   objDivPage.appendChild(objDivBack)
//   objDivPage.appendChild(objDivPrevPage)
//   objDivPage.appendChild(objDivNextPage)
//   objDivPage.appendChild(objDivZoomin)
//   objDivPage.appendChild(objDivZoomout)
//   objDivBack.innerHTML = '<img src="../images/scanicon-back.png" onclick="ChangeWordSize2(0)">'
//   objDivPrevPage.innerHTML = '<img src="../images/scanicon-left.png" onclick="ChangePrevPage2()">'
//   objDivNextPage.innerHTML = '<img src="../images/scanicon-right.png" onclick="ChangeNextPage2()">'
//   objDivZoomin.innerHTML = '<img src="../images/scanicon-big.png" onclick="ChangeWordSize2(11)">'
//   objDivZoomout.innerHTML = '<img src="../images/scanicon-small.png" onclick="ChangeWordSize2(-10)">'
//   objDivBack.className = 'div_img'
//   objDivPrevPage.className = 'div_img'
//   objDivNextPage.className = 'div_img'
//   objDivZoomin.className = 'div_img'
//   objDivZoomout.className = 'div_img'
//   objDivBack.style.top = (iDivPageHeight + 25) + 'px'
//   objDivPrevPage.style.top = (iDivPageHeight + 25) + 'px'
//   objDivNextPage.style.top = (iDivPageHeight + 25) + 'px'
//   objDivZoomin.style.top = (iDivPageHeight + 25) + 'px'
//   objDivZoomout.style.top = (iDivPageHeight + 25) + 'px'
//   objDivBack.style.left = (iDivPageWidth - 240) + 'px'
//   objDivPrevPage.style.left = (iDivPageWidth - 180) + 'px'
//   objDivNextPage.style.left = (iDivPageWidth - 130) + 'px'
//   objDivZoomin.style.left = (iDivPageWidth - 80) + 'px'
//   objDivZoomout.style.left = (iDivPageWidth - 40) + 'px'

  // 加载判断字体是否标红
  // if (cTurnRedFt.length > 1) {
  //    fonColor2(cTurnRedFt);
  // }
}

// 上一页
function ChangePrevPage2 () {
  if (iPageNo > 0) {
    iPageNo = iPageNo - 1
    parent.$('.nav_2:eq(' + iPageNo + ')').addClass('on').siblings('.nav_2').removeClass('on') // 左侧目录树高亮显示
    goMarkArt(iPageNo + 1, nOpenFc)
  } else {
    alert('已经是第一页！')
  }
}
// 下一页
function ChangeNextPage2 () {
  if (iPageNo < iTotalPages - 1) {
    iPageNo = iPageNo + 1
    parent.$('.nav_2:eq(' + iPageNo + ')').addClass('on').siblings('.nav_2').removeClass('on') // 左侧目录树高亮显示
    goMarkArt(iPageNo + 1, nOpenFc)
  } else {
    alert('已经是最后一页！')
  }
}

// 对字符大小进行缩放操作
// iSize大于0表示放大，小于0表示缩小，等于0表示还原
function ChangeWordSize2 (iSize) {
  if (iSize == 0) {
    iRowWidth = 40
    iFontSize = 24
  } else {
    iRowWidth = iRowWidth * (100 + iSize) / 100
    iFontSize = iFontSize * (100 + iSize) / 100
    if (iRowWidth > 80) { iRowWidth = 80 }
    if (iRowWidth < 20) { iRowWidth = 20 }
    if (iFontSize > 40) { iFontSize = 40 }
    if (iFontSize < 20) { iFontSize = 20 }
  }
  iFontSize = Math.ceil(iFontSize)
  iRowWidth = Math.ceil(iRowWidth)
  objDivRebuildPage = document.getElementById('sDivId')
  $(objDivRebuildPage).empty()	// 清空原来的内容
  ShowOnePage2(objDivRebuildPage)	// 重新显示
}
// 行中有标记，分析一行的各个部分
function ParseOneLine2 (objDivRow, sOneLine) {
  var arrayOneLine = new Array()
  SplitOneLine2(arrayOneLine, sOneLine)

  var i
  var sOnePart
  // 对于有两行并列的情况，判断第二行比第一行长时，在第一行后面补上空格,使得第一行的长度不会小于第二行的长度
  var iLen
  for (i = 0; i < arrayOneLine.length; i++) {
    sOnePart = arrayOneLine[i]
    if (sOnePart.indexOf('type="sbr"') >= 0) {
      iLen = arrayOneLine[i + 1].length
      sOnePart = arrayOneLine[i - 1]
      if (sOnePart.length < iLen) {
        while (sOnePart.length < iLen) {
          if (bIe == -1) // 非IE浏览器转换，因为界面上会显示白框，IE不显示
          { sOnePart += '　' } else { sOnePart += '䶻' }
        }
        arrayOneLine[i - 1] = sOnePart
      }
    }
  }

  var iDivWidth, iDivLeft, iPartFontSize
  iDivLeft = 0
  iDivWidth = iRowWidth
  iPartFontSize = iFontSize
  var objPart
  var iType = 0	// 该行中每一部分的类型，0：正常文本，1：标题，2：并列小文字的第一列，3：并列小文字的第二列
  // 分析一行的每一部分
  for (i = 0; i < arrayOneLine.length; i++) {
    sOnePart = arrayOneLine[i]
    if (sOnePart.indexOf('type="title.start"') >= 0) {
      // 标题开始
      iType = 1
      iDivLeft = 0
      iDivWidth = iRowWidth
      iPartFontSize = iFontSize * 1.2
    } else if (sOnePart.indexOf('type="title.end"') >= 0) {
      // 标题结束
      iType = 0
      iDivLeft = 0
      iDivWidth = iRowWidth
      iPartFontSize = iFontSize
    } else if (sOnePart.indexOf('type="small.start"') >= 0) {
      // 并列的小文字开始
      iType = 2
      iDivLeft = iRowWidth / 2
      iDivWidth = iRowWidth / 2
      iPartFontSize = iFontSize * 0.6	// 小字，显示为大字的60%宽度
    } else if (sOnePart.indexOf('type="sbr"') >= 0) {
      // 并列的第二列小文字开始
      iType = 3
      iDivLeft = 0
      iDivWidth = iRowWidth / 2
      iPartFontSize = iFontSize * 0.6
    } else if (sOnePart.indexOf('type="small.end"') >= 0) {
      // 并列的小文字结束
      iType = 0
      iDivLeft = 0
      iDivWidth = iRowWidth
      iPartFontSize = iFontSize
    } else if (sOnePart.indexOf('<mark') < 0) {
      if (iType < 3) {
        // 在文字外面再加上一个div，方便两列并列的文字定位
        objPart = document.createElement('div')
        objDivRow.appendChild(objPart)
        objPart.className = 'div_part'
        objPart.style.width = iRowWidth + 'px'
      }

      var objDivPart = document.createElement('div')
      objPart.appendChild(objDivPart)

      objDivPart.className = 'div_part_words'
      // sOnePart=AddDiv(sOnePart);
      cOneNew = sOnePart
      if (cTurnRed.length > 0) {
        cRepl = '/' + cTurnRed + '/g'
	      		cOneNew = cOneNew.replace(eval(cRepl), '<font color=red>' + cTurnRed + '</font>')
	      		if (cTurnFt != cTurnRed) {
	      			cReplFt = '/' + cTurnFt + '/g'
	            	cOneNew = cOneNew.replace(eval(cReplFt), '<font color=red>' + cTurnFt + '</font>')
	            }
	        }
      objDivPart.innerHTML = cOneNew
      objDivPart.style.fontSize = iPartFontSize + 'px'

      if (iType < 2) {
        objDivPart.style.left = ((iDivWidth - iPartFontSize) / 2) + 'px'
        objDivPart.style.width = iPartFontSize + 'px'
      } else {
        objDivPart.style.left = iDivLeft + 'px'
        objDivPart.style.width = iDivWidth + 'px'
      }

      if (iType == 3)	// 第二小列用绝对定位
      { objDivPart.style.position = 'absolute' }
    }
  }
}

// 将一行的内容根据标记进行拆分，结果保存到数组中
function SplitOneLine2 (arrayLine, sStr) {
  var iPos
  var sOnePart
  while (sStr.length > 0) {
    iPos = sStr.indexOf('<')
    if (iPos < 0) {
      arrayLine[arrayLine.length] = sStr
      break
    }

    sOnePart = sStr.substr(0, iPos)
    sStr = sStr.substr(iPos)
    if (sOnePart.length > 0) {
      arrayLine[arrayLine.length] = sOnePart
    }
    iPos = sStr.indexOf('>')
    if (iPos < 0) {
      arrayLine[arrayLine.length] = sStr
      break
    }
    sOnePart = sStr.substr(0, iPos + 1)
    sStr = sStr.substr(iPos + 1)

    if (sOnePart == '</mark>') { sOnePart = '' }

    if (sOnePart.length > 0) {
      arrayLine[arrayLine.length] = sOnePart
    }
  }
}

// 获取一行的长度
function GetOneLineLen2 (sOneLine) {
  var sThisStr = sOneLine
  sThisStr = sThisStr.replace('<mark type="select.start" kind="SELECT"></mark>', '')
  sThisStr = sThisStr.replace('<mark type="select.end"></mark>', '')

  if (sThisStr.indexOf('<mark') >= 0) {
    // 重新组合串，删除标记及小字中的第二行字
    var arrayOneLine = new Array()
    SplitOneLine2(arrayOneLine, sOneLine)
    sThisStr = ''
    var iType = 0
    for (var i = 0; i < arrayOneLine.length; i++) {
      var sOnePart = arrayOneLine[i]

      if (sOnePart.indexOf('<mark') >= 0) {
        if (sOnePart.indexOf('type="sbr"') > 0) {
          iType = 1// 第二列，不计入长度
        } else { iType = 0 }
        if (sOnePart.indexOf('type="small.end"') > 0) { iType = 0 }
        sOnePart = ''
      }

      if (iType == 1) { sOnePart = '' }	// 第二列，不计入长度
      sThisStr += sOnePart
    }
  }
  return sThisStr.length
}

// 显示书名
function AddBookName2 (objDivRow_Line) {
  var iHeight = objDivRow_Line.style.height
  var objBookName = document.createElement('div')
  var objFlag = document.createElement('div')
  var objPageNo = document.createElement('div')
  objBookName.className = 'div_bookname'
  objFlag.className = 'div_flag'
  objPageNo.className = 'div_pageno'
  objDivRow_Line.appendChild(objBookName)
  objDivRow_Line.appendChild(objFlag)
  objDivRow_Line.appendChild(objPageNo)

  var cName = cBookName
  console.log('cName', cName)
  cName = cName.replace('《', '').replace('》', '')
  objBookName.innerHTML = cName
  objFlag.innerHTML = '︻'

  objBookName.style.fontSize = iFontSize * 1.2 + 'px'
  objBookName.style.left = (iRowWidth - iFontSize * 1.2) / 2 + 'px'
  objBookName.style.width = iFontSize * 1.2 + 'px'

  objFlag.style.fontSize = iRowWidth + 'px'
  objFlag.style.left = '-1px'

  objPageNo.innerHTML = GetChinesePageNo2(currentPage)
  objPageNo.style.fontSize = iFontSize * 0.6 + 'px'
  objPageNo.style.left = (iRowWidth - iFontSize * 0.6) / 2 + 'px'
  objPageNo.style.width = iFontSize * 0.6 + 'px'
}
// 将数字页码转换为中文页码
function GetChinesePageNo2 (iPageNo) {
  var iOne, iTen, iPercent, iThousand
  iThousand = Math.floor(iPageNo / 1000)
  iPercent = Math.floor((iPageNo % 1000) / 100)
  iTen = Math.floor((iPageNo % 1000 % 100) / 10)
  iOne = iPageNo % 1000 % 100 % 10
  var sOne, sTen, sPercent, sThousand
  sThousand = ToChinese2(iThousand)
  sPercent = ToChinese2(iPercent)
  sTen = ToChinese2(iTen)
  sOne = ToChinese2(iOne)
  var sRet = ''
  if (iThousand > 0) { sRet = sThousand + '千' }
  if (iPercent > 0) { sRet = sRet + sPercent + '百' } else { sRet = sRet + sPercent }
  if (iTen > 0) { sRet = sRet + sTen + '十' } else { sRet = sRet + sTen }
  if (iOne > 0) { sRet = sRet + sOne }

  // 删除前面的零
  while (sRet.substr(0, 1) == '零') { sRet = sRet.substr(1) }
  // 删除后面的零
  while (sRet.substr(sRet.length - 1) == '零') { sRet = sRet.substr(0, sRet.length - 1) }
  sRet = sRet.replace('零零', '零')
  return sRet
}
// 将数字转换为中文
function ToChinese2 (iNo) {
  var sChinese = '零一二三四五六七八九'
  return sChinese.substr(iNo, 1)
}
// 判断
function IEVersion () {
  var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    var fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion == 7) {
      return 7
    } else if (fIEVersion == 8) {
      return 8
    } else if (fIEVersion == 9) {
      return 9
    } else if (fIEVersion == 10) {
      return 10
    } else {
      return 6// IE版本<=7
    }
  } else if (isEdge) {
    return 11 // IE edge
  } else if (isIE11) {
    return 11 // IE11
  } else {
    return -1// 不是ie浏览器
  }
}

function AddDiv (para) {
  sNewOne = ''
  for (var i = 0; i < para.length; i++) {
    one = para.substr(i, 1)
    sNewOne = sNewOne + '<div class=mypart>' + one + '</div>'
  }
  // alert(sNewOne)
  return sNewOne
}

// 报红字数
function fonColor2 (font) {
  // font = "人参|人參";
  var strfontlist = [] // 检索到的字
  var strfontlength = []
  var countup = 0 // 统计
  // 获取当前页面的所有字
  var fontstr = ''
  $.each($('.mypart'), function (i, n) {
    if ($(this).html().indexOf('img') == -1) {
      fontstr += $(this).html()
    } else {
      fontstr += '*'
    }
  })
  // 比较
  var fonts = font.split('|')
  var strLeng = fontstr // 临时变量
  for (var p = 0, i = 0; i < fonts.length; i++) {
    if (p == 1) {
      fontstr = strLeng
      countup = 0
    }
    if (fontstr.indexOf(fonts[i]) > -1) { // 进行匹配
      var fonlength = SplitStringToArray(fonts[i]).length
      //
      var indexfor = fontstr.indexOf(fonts[i])
      var strFons = fontstr.substring(0, indexfor)
      var indexlngth = strFons == '' ? 0 : SplitStringToArray(strFons).length //
      strfontlist.push(indexlngth + countup)
      strfontlength.push(fonlength)
      fontstr = fontstr.substring(indexfor + fonts[i].length, fontstr.length)
      //
      countup += indexlngth + fonts[i].length
      i--
      p = 0
    } else {
      p = 1
    }
  }
  TURNHEAD = ''; TURNTAIL = ''
  // 跨页检索
  for (var i = 0; i < fonts.length; i++) {
    var fonSplits = SplitStringToArray(fonts[i])
    var strSplits = SplitStringToArray(fontstr)
    var fristNo = true, lastNo = true
    for (var k = 0; k < fonts[i].length; k++) {
      // 首部检索
      var fontext = fonts[i].substring(k, fonts[i].length)
      if (fontstr.indexOf(fontext) > -1 && fristNo) {
        var indexfor = fontstr.indexOf(fontext)
        if (indexfor == 0) {
          TURNHEAD = fontext
          var fonlength = SplitStringToArray(fontext).length
          //
          var strFons = fontstr.substring(0, indexfor)
          var indexlngth = strFons == '' ? 0 : SplitStringToArray(strFons).length //
          strfontlist.push(indexlngth)
          strfontlength.push(fonlength)
          fristNo = false
        }
        //
      }
      // 尾部检索
      var fontext = fonts[i].substring(0, fonts[i].length - k)
      if (fontstr.indexOf(fontext) > -1 && lastNo) {
        var indexfor = fontstr.lastIndexOf(fontext)
        if (indexfor >= fontstr.length - fonts[i].length) {
          TURNTAIL = fontext
          var fonlength = SplitStringToArray(fontext).length
          //
          var strFons = fontstr.substring(0, indexfor)
          var indexlngth = strFons == '' ? 0 : SplitStringToArray(strFons).length //
          strfontlist.push(indexlngth)
          strfontlength.push(fonlength)
          lastNo = false
          //
        }
      }
    }
  }

  // 标红
  $.each($('.mypart'), function (i, n) {
    for (var j = 0; j < strfontlist.length; j++) {
      if (strfontlist[j] == i) {
        $(this).css('color', 'red')
        var fonthis = $(this)
        var b = i
        for (var k = 1; k < strfontlength[j]; k++) {
          $($('.mypart')[b + 1]).css('color', 'red')
          fonthis = fonthis.next()
          b++
        }
      }
    }
  })
}
module.exports = {
  ParseXml2, ChangeWordSize2
}



// WEBPACK FOOTER //
// ./src/assets/showvpage2.js